export const LOGO_ICON_DARK_SVG = {
  width: '171',
  height: '173',
  viewBox: '0 0 171 173',
};
